














































import { ElTable } from "element-ui/types/table";
import { Component, Mixins, } from "vue-property-decorator";
import { CommentsMixedListTableMixin } from "./mixins";
import CommentSelectableDialog from "../../dialogs/CommentSelectableDialog.vue";

@Component({
  components: {
    CommentSelectableDialog,
  }
})
export default class CommentsMixedListTable extends Mixins(CommentsMixedListTableMixin) {
  $refs!: {
    table: ElTable;
    commentSelectableDialog: CommentSelectableDialog;
  };

  activated() {
    this.$doWhenValid(t => t.doLayout(), this.$refs.table);
  }

  async addComment(): Promise<void> {
    const result = await this.$refs.commentSelectableDialog.show(
      {
        name: "コメント追加",
        labelSetting: this.labelSetting,
        enableKinds: this.addibleCommentKinds,
        defaultAdditionalCommentType: this.commentSetting.commentsMixedDefaultAdditionalCommentType,
        reference: this.commentSet
          ? {
            labelSetting: this.labelSetting,
            comments: {
              defaultSortType: this.commentDefaultSortType,
              shouldSortCommentAsc: this.shouldSortCommentAsc,
              nextMessages: {
                unit: this.nextMessageUnitKind,
                comments: this.commentSet.nextMessages,
              },
              backMessages: {
                unit: this.commentUnitKind,
                comments: this.commentSet.backMessages,
              },
            },
          }
          : null,
      }
    );
    if (result.isConfirmed) {
      this.registerNewComment(result.kind, result.comment);
    }
  }
}
